import React, { memo, useCallback, useMemo } from 'react';

import { FormattedMessage } from 'react-intl';

import { DropdownMenu } from 'ui-components/components/dropdown-menu';
import { DropdownMenuType } from 'ui-components/components/dropdown-menu/dropdown-menu-type';
import { DropdownMenuItem } from 'ui-components/components/dropdown-menu-item';
import { DropdownMenuToggler } from 'ui-components/components/dropdown-menu-toggler';
import { Text, TextType } from 'ui-components/components/text';

import { useRateViewerContext } from './rate-viewer-context-provider';
import { RateViewerView } from './views/rate-viewer-view';

import { messages } from './messages';
import style from './rate-viewer-header.module.css';

const VIEW_DROPDOWN_ID = 'rate-viewer-view-dropdown';

const rateViewerViewMessageDescriptorMap = {
  [RateViewerView.AllRates]: messages.allRatesOption,
  [RateViewerView.Carriers]: messages.carriersOption,
};

export const RateViewerHeader = memo(() => {
  const { updateSelectedView, rateProvidersLoadedCount, rateProvidersRequestedCount, selectedView, shouldShowProgress } =
    useRateViewerContext();
  const selectAllRatesView = useCallback(() => {
    updateSelectedView(RateViewerView.AllRates);
  }, [updateSelectedView]);

  const selectCarrierView = useCallback(() => {
    updateSelectedView(RateViewerView.Carriers);
  }, [updateSelectedView]);

  const progressFormattedMessageValues = useMemo(() => {
    return {
      rateProvidersLoadedCount,
      rateProvidersRequestedCount,
    };
  }, [rateProvidersLoadedCount, rateProvidersRequestedCount]);

  return (
    <div className={style['rate-viewer-header']}>
      <div className={style['header-text-container']}>
        <Text textType={TextType.H2} value={messages.rateViewerHeader} />
        {shouldShowProgress && (
          <Text formattedMessageValues={progressFormattedMessageValues} textType={TextType.Caption} value={messages.rateViewerProgress} />
        )}
      </div>
      <div className={style['sort-by-container']}>
        <Text element='label' htmlFor={VIEW_DROPDOWN_ID} textType={TextType.Paragraph} value={messages.viewDropdownLabel} />
        <DropdownMenu dropdownMenuType={DropdownMenuType.ComboBox} id={VIEW_DROPDOWN_ID}>
          <DropdownMenuToggler theme='tertiary'>
            <FormattedMessage {...rateViewerViewMessageDescriptorMap[selectedView]} />
          </DropdownMenuToggler>
          <DropdownMenuItem onClick={selectAllRatesView}>
            <FormattedMessage {...rateViewerViewMessageDescriptorMap[RateViewerView.AllRates]} />
          </DropdownMenuItem>
          <DropdownMenuItem onClick={selectCarrierView}>
            <FormattedMessage {...rateViewerViewMessageDescriptorMap[RateViewerView.Carriers]} />
          </DropdownMenuItem>
        </DropdownMenu>
      </div>
    </div>
  );
});
